import React, { useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import AuthService from "../services/AuthService";

const CHECK_INTERVAL = 10 * 1000; // vérifie la session toutes les 10s

const ActivityTracker = ({ children }) => {
    const { logout, isAuthenticated } = useContext(AuthContext);

    useEffect(() => {
        const resetInactivityTimer = () => {
            if (isAuthenticated) {
                AuthService.recordActivity();
            }
        };

        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
        events.forEach(event => window.addEventListener(event, resetInactivityTimer));

        // Déconnecte automatiquement si la session expire pendant que l'app est ouverte
        const interval = setInterval(() => {
            if (isAuthenticated && !AuthService.isSessionValid()) {
                logout();
            }
        }, CHECK_INTERVAL);

        return () => {
            events.forEach(event => window.removeEventListener(event, resetInactivityTimer));
            clearInterval(interval);
        };
    }, [isAuthenticated, logout]);

    return <>{children}</>;
};

export default ActivityTracker;